<template>
    <v-container fluid px-4 py-0 pt-1 grid-list-lg>
        <v-layout row wrap>
            <v-flex xs12></v-flex>
            <v-flex xs12>
                <h3>Letter Templates</h3>
            </v-flex>
        </v-layout>
        <v-layout><v-flex></v-flex></v-layout>
        <v-layout row wrap v-if="!editHeader">
            <v-flex xs12 sm6 md3><v-btn color="secondary" @click="toggleEditHeader">Edit Header</v-btn></v-flex>
        </v-layout>
        <v-layout row wrap v-else>
            <v-flex xs12><h4>Header Template</h4></v-flex>
            <template v-if="isAdmin">
                <v-flex xs12 sm6 py-0>
                    <v-autocomplete browser-autocomplete='no' v-model="selectedHeaderCountyId" :items="countyList" item-text="description"
                    item-value="id" label="Select County" :rules="[v => !!v || 'County is required']" required @change="adminHeaderLoaded = false"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md3><v-btn color="secondary" @click="loadCountyHeader">Load Header</v-btn></v-flex>
                <v-flex xs12 sm6 md3 v-if="!adminHeaderLoaded"><v-btn color="secondary" @click="toggleEditHeader">Done</v-btn></v-flex>
            </template>
            <v-flex xs12 v-if="isHeaderLoading"><loader :small="true"/></v-flex>
            <template v-if="!isAdmin || adminHeaderLoaded" v-show="!isHeaderLoading">
                <v-flex xs12>
                    <div>
                        <editor id="headerEditor" v-model="letterTemplateHeaderDto.headerHtml" :init="headerEditor.options"></editor>
                    </div>
                </v-flex>
                <v-flex xs12 sm6 md3><v-btn color="secondary" @click="saveHeader">Save Header</v-btn></v-flex>
                <v-flex xs12 sm6 md3><v-btn color="secondary" @click="toggleEditHeader">Done</v-btn></v-flex>
            </template>
        </v-layout>
        <v-layout><v-flex><v-divider></v-divider></v-flex></v-layout>
        <v-layout row wrap>
            <v-flex xs12><h4>Letter Templates</h4></v-flex>
            <template v-if="isAdmin">
                <v-flex xs12 sm6 py-0>
                    <v-autocomplete browser-autocomplete='no' v-model="selectedTemplateCountyId" :items="countyList" item-text="description"
                    item-value="id" label="Select County" :rules="[v => !!v || 'County is required']" required ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md3><v-btn color="secondary" @click="loadCountyTemplates">Load Template</v-btn></v-flex>
            </template>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        <v-text-field
                            v-model="templateTableFilter"
                            append-icon="search"
                            label="Filter"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="newTemplate">Create New Template</v-btn>
                    </v-card-title>
                    <v-data-table
                    :headers="TableHeaders"
                    :items="templateResults"
                    :search="templateTableFilter"
                    :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs"><v-btn icon @click="goTemplateRow(props.item.letterTemplateId)"><v-icon>assignment</v-icon></v-btn></td>
                            <td class="text-xs">{{ props.item.letterTemplateTypeId }}</td>
                            <td class="text-xs">{{ props.item.templateName }}</td>
                            <td class="text-xs">{{ props.item.createdBy }}</td>
                            <td class="text-xs">{{ props.item.createdDate }}</td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>

import userService from '@/services/userService'
import letterTemplateService from '@/services/letterTemplateService'
import lookupService from '@/services/lookup/lookupService'
//import tinymce from 'tinymce/tinymce'
import editor from '@tinymce/tinymce-vue'
import loader from '@/components/Loader'

export default {
    name: 'LetterTemplates',
    components: {
        editor,
        loader
    },
    props: {
        coronerUserDto: {},
        authProfile: {}
    },
    data: function () {
        return {
            isDebug: false,
            isHeaderLoading: false,
            countyList: [],
            selectedHeaderCountyId: null,
            adminHeaderLoaded: false,
            editHeader: false,
            headerEditor: {
                options: {
                    selector: '#headerEditor',
                    height: 100,
                    plugins: 'lists paste table image',
                    oninit: 'setPlainText',
                    forced_root_block: false,
                    menubar: 'edit format insert',
                    toolbar: 'fontselect fontsizeselect bullist table image',
                    relative_urls: false,
                    remove_script_host: false,
                    convert_urls: true
                }
            },
            letterTemplateHeaderDto: {
                headerHtml: ''
            },
            selectedTemplateCountyId: 0,
            templateTableFilter: '',
            TableHeaders: [
                { text: 'View', sortable: 'false', value: 'letterTemplateId' },
                { text: 'Template Type', value: 'letterTemplateTypeId' },
                { text: 'Template Name', value: 'templateName' },
                { text: 'Created By', value: 'createdBy' },
                { text: 'Created Date', value: 'createdDate' }
            ],
            templateResults: []
        }
    },
    computed: {
        isAdmin: function () {
            return (this.coronerUserDto && userService.isAdministrator(this.coronerUserDto.roleList))
        },
        selectedCountyDescription: function () {
            return (this.countyList.find(x => {
                return x.id === this.letterTemplateHeaderDto.countyId
            }) || { description: 'None' }).description
        }
    },
    mounted () {
        this.loadLookup('County', 'countyList')
        if (this.coronerUserDto && !this.isAdmin) {
            this.loadCountyTemplates()
        }
    },
    methods: {
        loadLookup (lookupName, dataName) {
            return lookupService.listLookup(this.$http, lookupName).then(response => {
                this[dataName] = response.data
            })
        },
        toggleEditHeader () {
            if (!this.editHeader && !this.isAdmin) {
                this.isHeaderLoading = true
                letterTemplateService.getHeader(this.$http).then(response => {
                    if (response.data) {
                        this.letterTemplateHeaderDto = response.data
                    }
                    this.editHeader = !this.editHeader
                    this.isHeaderLoading = false
                })
            } else {
                this.editHeader = !this.editHeader
            }
        },
        saveHeader () {
            letterTemplateService.saveHeader(this.$http, this.letterTemplateHeaderDto)
        },
        loadCountyHeader () {
            //reset letterTemplateHeaderDto
            this.letterTemplateHeaderDto = {
                countyId: this.selectedHeaderCountyId,
                headerHtml: ''
            }
            this.isHeaderLoading = true
            letterTemplateService.getHeaderByCountyId(this.$http, this.selectedHeaderCountyId).then(response => {
                if (response.data) {
                    this.letterTemplateHeaderDto = response.data
                }
                this.adminHeaderLoaded = true
                this.isHeaderLoading = false
            })
        },
        loadCountyTemplates () {
            letterTemplateService.listTemplateByCountyId(this.$http, this.selectedTemplateCountyId).then(response => {
                this.templateResults = response.data
            })
        },
        newTemplate () {
            this.$router.push('/lettertemplate/')
        },
        goTemplateRow (id) {
            this.$router.push('/lettertemplate/' + id)
        }
    }
}
</script>
